import axios from 'axios'
import {
  setFormValues,
  setFilterValues,
  toggleFilterValues,
} from '../../../modules/mutations.js'
import {i18n} from '../../../plugins/i18n'

export const companiesCompetitorsReviews = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    formValues: {},
    filteredCount: 0,
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    apiSuccess(state, payload) {
      state.loading = false
      state.data = payload
    },
    apiFailure(state) {
      state.loading = false
    },
    setValuesForFilter(state, payload) {
      state.filteredCount = payload.meta.total_count
    },
    setFormValues,
    setFilterValues,
    toggleFilterValues,
  },
  actions: {
    readCompetitorsReviews({ commit }, payload) {
      commit('prepareConnect')
      axios
        .post(
          `/api/companies/${ payload.company_uuid }/competitors/reviews.json${ window.location.search }`,
          payload.values
        )
        .then(res => {
          commit('apiSuccess', res.data)
          commit('setValuesForFilter', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    readCompetitorsReviewsForFilter({ commit }, payload) {
      axios
        .post(
          `/api/companies/${ payload.company_uuid }/competitors/reviews.json${ window.location.search }`,
          payload.values
        )
        .then(res => {
          commit('setValuesForFilter', res.data)
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    createCompetitorsCsv({ commit }, payload) {
      commit('prepareConnect')
      return axios
        .post(`/api/companies/${payload.company_uuid}/export/competitor_reviews`, payload.values)
        .then(() => {
          commit('createCsvSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('pages.CompaniesExportResults.startDownloadPreparation')}, { root: true })
        })
        .catch(err => {
          commit('createCsvFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          throw err
        })
    }
  }
}
